module.exports = __webpack_public_path__ + "static/media/host_4pos.28e6486a.png";